
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/overview",
      function () {
        return require("private-next-pages/d/account/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/overview"])
      });
    }
  